import { defineComponent } from 'vue';
export default defineComponent({
    name: 'TitleAndDescription',
    compatConfig: {
        MODE: 3,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
    },
});
